import React, { useContext, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, loading, logout } = useContext(AuthContext);
  const location = useLocation();

  // Validate session on every route change
  useEffect(() => {
    if (user) {
      const lastActivity = parseInt(localStorage.getItem('lastActivity') || Date.now());
      const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes
      
      if (Date.now() - lastActivity > SESSION_TIMEOUT) {
        logout();
      }
    }
  }, [location, user, logout]);

  // If loading, show loading spinner or message
  if (loading) {
    return <div className="text-center my-5">Loading...</div>;
  }

  // If not logged in, redirect to login page
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If role requirement is specified and user doesn't have required role
  if (requiredRole && user.role !== requiredRole && user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute; 